import React from 'react'
import { NumberColumn, Column, WidgetCell, NumberField } from '@sencha/ext-modern'

import { genWidgetcellChangeHandler } from './utilities'

const render = ({ _float: text, dataIndex, format = '0,000.00', handleEdit, edit, align = 'right', ...rest }) => {
	return edit
		? <Column {...{ dataIndex, text, align, ...rest }}>
			<WidgetCell bodyStyle={{ padding: "0px 12px" }}>
				<NumberField {...{ decimals: 2, thousandsSeperator: true, textAlign: align, trim: false, }}
					clearable={false}
					onChange={genWidgetcellChangeHandler(handleEdit, dataIndex, 'number')}
					{...edit}
				/>
			</WidgetCell>
		</Column>
		: <NumberColumn {...{ dataIndex, text, align, format, ...rest }} />
}

export default render